





























import theme from '@zk/theme/lib/variables.scss';
import { defineComponent, toRef, computed } from '@vue/composition-api';

import TheLayoutArea from './TheLayoutArea.vue';
import { useFieldLayout } from '../store';
import { PLACABLE_FIELDS_LEFT } from '../common/config';

export default defineComponent({
  name: 'TheRightArea',
  components: {
    TheLayoutArea
  },
  props: {},
  setup() {
    const store = useFieldLayout();

    // 检验字段是否可以拖入右侧
    const dragPutInspection = () => {
      const { controlCode, fieldCode: _fieldCode } = store.dragTargetInfo || {};
      const fieldCode = _fieldCode || store.dragTargetCode;

      if (!store.dragTargetCode) {
        return false;
      }
      return [controlCode, fieldCode].every(type => !PLACABLE_FIELDS_LEFT.includes(type));
    };

    const isHighlight = computed(() => store.isDragging && dragPutInspection());

    return {
      fields: toRef(store, 'rightAreaFields'),
      createLoading: toRef(store, 'checkAddLoading'),
      isHighlight,
      dragPutInspection
    };
  },
  data() {
    return {
      bemNS: theme.bemNS
    };
  }
});
